import { render, staticRenderFns } from "./ConfiguracoesSistema.vue?vue&type=template&id=77048b53&scoped=true&"
import script from "./ConfiguracoesSistema.vue?vue&type=script&setup=true&lang=js&"
export * from "./ConfiguracoesSistema.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77048b53",
  null
  
)

export default component.exports